import { observer } from 'mobx-react-lite'
import { useEventCallEnded } from 'entities/Call/events/EventCallEnded'
import { useEventCallTransferFailed } from 'entities/Call/events/EventCallTransferFailed'
import { useEventCallTransferSucceeded } from 'entities/Call/events/EventCallTransferSucceeded'

export const GlobalLightEvents = observer(() => {
  useEventCallEnded()
  useEventCallTransferFailed()
  useEventCallTransferSucceeded()

  return null
})
